import script from "./Clientes.vue?vue&type=script&setup=true&lang=js"
export * from "./Clientes.vue?vue&type=script&setup=true&lang=js"

import "./Clientes.vue?vue&type=style&index=0&id=8abd949c&scoped=true&lang=scss"
import "./Clientes.vue?vue&type=style&index=1&id=8abd949c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8abd949c"]])

export default __exports__